import React from 'react';
import { motion } from 'framer-motion';
import './UpcomingEvents.css';

import webathon from '../assets/upcoming_events/webathon.jpeg';

const eventsData = [
    {
        title: 'National Level AI Fusion Webathon',
        date: 'October 22, 2026',
        time: '10:30 AM',   
        venue: 'IT Complex, PCE Nagpur',
        link: ' https://acm-ai-fusion26.vercel.app/',
        // description: '',
        image: webathon,
    }

];

const UpcomingEvents = () => {
    return (
        <section className="upcoming-events-section">
            <h2 className="upcoming-events-title">
                Our Upcoming <span>Events...</span>
            </h2>
            <div className="events-carousel">
                {eventsData.map((event, index) => (
                    <motion.div 
                        className="upcoming-event-card" 
                        key={index}
                        initial={{ opacity: 0, y: 50 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true }}
                        transition={{ duration: 0.5, delay: index * 0.2 }}
                        whileHover={{ scale: 1.05 }}
                    >
                        <img src={event.image} alt={event.title} className="upcoming-event-image" />
                        <div className="upcoming-event-details">
                            <h3>{event.title}</h3>
                            <p className="event-info"><strong>Date:</strong> {event.date}</p>
                            <p className="event-info"><strong>Time:</strong> {event.time}</p>
                            <p className="event-info"><strong>Venue:</strong> {event.venue}</p>
                            {event.link && <a href={event.link} target="_blank" rel="noopener noreferrer" className="register-link">Register Here</a>}
                            <p className="event-description-small">{event.description}</p>
                        </div>
                    </motion.div>
                ))}
            </div>
        </section>
    );
};

export default UpcomingEvents;
